import common from '@/services/common'

export default {
  async create(majorID, fileName) {
    console.log("apifile - create(", majorID, fileName, ")")
    const body = {
      majorId: majorID,
      fileName: fileName,
    }
    return common.execute("POST", `/api/appconfig/v1/files`, body)
  },
  async retrieve(fileID) {
    console.log("apifile - retrieve(", fileID, ")")
    return common.execute("GET", `/api/appconfig/v1/files/${fileID}`)
  },
  async details(fileID) {
    console.log("apifile - details(", fileID, ")")
    return common.execute("GET", `/api/appconfig/v1/files/${fileID}/details`).then(result => {
      if (!result.minor) {
        return Object.assign({ minor: {}}, result)
      }
      return result
    })
  },
}